import { render, staticRenderFns } from "./HotelEdit.vue?vue&type=template&id=2272b852&scoped=true&"
import script from "./HotelEdit.vue?vue&type=script&lang=ts&"
export * from "./HotelEdit.vue?vue&type=script&lang=ts&"
import style0 from "./HotelEdit.vue?vue&type=style&index=0&id=2272b852&prod&lang=scss&"
import style1 from "./HotelEdit.vue?vue&type=style&index=1&id=2272b852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272b852",
  null
  
)

export default component.exports